import React, {Component} from 'react'
import {Collapse} from "reactstrap"
import PropTypes from 'prop-types'

class BillingCollapse extends Component {

    render() {
        const extend = this.props.extend || {}
        const {collapse} = this.props;
        let displayer = [];
        for (let property in extend) {
            displayer = [].concat(displayer, {
                key: property,
                value: extend[property],
            })
        }
        return (
            <div className='BillingCollapse'>
                <Collapse isOpen={collapse}>
                    <div className='row '>
                        <div className='col-2'/>
                        <div className='col-8 extend-table'>
                            <div className='row table-row'>
                                <div className='col-12 extend-table-title'>Meta data</div>

                            </div>
                            {
                                displayer.map((x, index) => {
                                    return (
                                        <div className='row table-row' key={`billing-collapse${index}`}>
                                            <div className='col-4'>{x.key}</div>
                                            <div
                                                className='col-8'>{typeof(x.value) === 'string' ? x.value : JSON.stringify(x.value)}</div>
                                        </div>
                                    )

                                })
                            }
                        </div>
                    </div>
                </Collapse>
            </div>
        )
    }
}

BillingCollapse.defaultProps = {
    extend: {}
};

BillingCollapse.propTypes = {
    collapse: PropTypes.bool.isRequired,
    extend: PropTypes.object,
}

export default BillingCollapse


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/billings/BillingsPage/BillingCollapse.js